import { render, staticRenderFns } from "./westudyOnline.vue?vue&type=template&id=0ccd9a26&scoped=true&"
import script from "./westudyOnline.vue?vue&type=script&lang=js&"
export * from "./westudyOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccd9a26",
  null
  
)

export default component.exports